import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=6cbde1f1"
import script from "./noticeList.vue?vue&type=script&lang=ts"
export * from "./noticeList.vue?vue&type=script&lang=ts"
import style0 from "./noticeList.vue?vue&type=style&index=0&id=6cbde1f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports